import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "spinner-container" }, [
      _createElementVNode("div", {
        class: "spinner-border custom-spinner",
        role: "status"
      }, [
        _createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
      ]),
      _createElementVNode("span", { class: "loading-text" }, "Carregando...")
    ], -1)
  ]))]))
}